export const IS_LOADING = "IS_LOADING"
// calendars

export const SET_CALENDARS_SUCCESS = "SET_CALENDARS_SUCCESS"
export const SET_USER_CALENDAR_SUCCESS = "SET_USER_CALENDAR_SUCCESS"
export const SET_USER_CALENDAR_FAILURE = "SET_USER_CALENDAR_FAILURE"
export const CREATE_USER_CALENDAR_SUCCESS = "CREATE_USER_CALENDAR_SUCCESS"
export const EDIT_USER_CALENDAR_SUCCESS = "EDIT_USER_CALENDAR_SUCCESS"
export const DELETE_USER_CALENDAR_SUCCESS = "DELETE_USER_CALENDAR_SUCCESS"

export const SET_CALENDAR_SUBSCRIPTION_ID = "SET_CALENDAR_SUBSCRIPTION_ID"
export const SUBSCRIBE_TO_CALENDAR_SUCCESS = "SUBSCRIBE_TO_CALENDAR_SUCCESS"
export const UNSUBSCRIBE_CALENDAR_SUCCESS = "UNSUBSCRIBE_CALENDAR_SUCCESS"
export const CALENDAR_SUBSCRIPTION_FAILURE = "CALENDAR_SUBSCRIPTION_FAILURE"

// events
export const SET_MY_CALENDAR_EVENTS_SUCCESS = "SET_MY_CALENDAR_EVENTS_SUCCESS"
export const SET_MY_CALENDAR_EVENTS_FAILURE = "SET_MY_CALENDAR_EVENTS_FAILURE"
export const CREATE_CALENDAR_EVENT_SUCCESS = "CREATE_CALENDAR_EVENT_SUCCESS"
export const EDIT_CALENDAR_EVENT_SUCCESS = "EDIT_CALENDAR_EVENT_SUCCESS"
export const DELETE_CALENDAR_EVENT_SUCCESS = "DELETE_CALENDAR_EVENT_SUCCESS"
export const CRUD_OPS_CALENDAR_EVENT_FAILURE = "CRUD_OPS_CALENDAR_EVENT_FAILURE"
export const SET_USER_CALENDAR_EVENT = "SET_USER_CALENDAR_EVENT"
export const SET_SHOW_EVENTS = "SET_SHOW_EVENTS"

//utilities
export const SET_CALENDAR_COLORS_SUCCESS = "SET_CALENDAR_COLORS_SUCCESS"
export const SET_CALENDAR_UTILITIES_FAILURE = "SET_CALENDAR_UTILITIES_FAILURE"
